// Custom hook for authentication state

import { useState, useEffect } from 'react';

export function useAuth() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('sessionToken');
    setIsAuthenticated(!!token);
    setIsLoading(false);
  }, []);

  const login = (token: string, email: string) => {
    localStorage.setItem('sessionToken', token);
    localStorage.setItem('userEmail', email);
    setIsAuthenticated(true);
  };

  const logout = () => {
    localStorage.removeItem('sessionToken');
    localStorage.removeItem('userEmail');
    setIsAuthenticated(false);
  };

  return { isAuthenticated, isLoading, login, logout };
}
